import { AuditModel } from "./Audit.model";

export class Audit extends AuditModel {
    // Add custom methods here
}
